export default "__VITE_ASSET__luvlmmPH__"